import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Layers, Loader2, ArrowRight } from 'lucide-react';
import { getPublicSeries } from '../services/cms';

const SeriesList = () => {
  const [series, setSeries] = useState(null);

  useEffect(() => {
    getPublicSeries().then(setSeries).catch(() => setSeries([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 min-h-[60vh]">
      <h1 className="font-display font-700 text-4xl text-foreground mb-2 flex items-center gap-3"><Layers className="w-8 h-8 text-primary" /> Séries à lire</h1>
      <p className="text-muted-foreground font-600 mb-10 max-w-2xl">Les séries de webtoons publiées, épisode par épisode. Lecture verticale, pensée pour le mobile.</p>

      {series === null ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : series.length === 0 ? (
        <div className="text-center py-20"><p className="font-display font-600 text-xl text-muted-foreground">Aucune série publiée pour le moment.</p></div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {series.map((s, i) => (
            <Link key={s.id} to={`/serie/${s.slug}`} className="card-hover group bg-card rounded-3xl overflow-hidden border border-border animate-float-up" style={{ animationDelay: `${i * 70}ms` }}>
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={s.couverture_url} alt={s.titre} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                {s.statut === 'termine' && <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[11px] font-800 text-white bg-green-600 uppercase">Terminée</span>}
                <div className="absolute bottom-3 left-4 right-4 text-white">
                  <h3 className="font-display font-600 text-xl leading-tight">{s.titre}</h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{s.resume}</p>
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-sm font-700 text-foreground"><BookOpen className="w-4 h-4 text-primary" /> {s.episodes_count} épisode{s.episodes_count > 1 ? 's' : ''}</span>
                  <span className="flex items-center gap-1 text-primary font-800 text-sm group-hover:gap-2 transition-all">Lire <ArrowRight className="w-4 h-4" /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SeriesList;
